angular.module('avant.constants', []).constant("CONFIG", {
  heapToken: window.avantEnv.HEAP_TOKEN,
  olarkServGroup: window.avantConfig.customerApplication.olark.serv,
  olarkOrigGroup: window.avantConfig.customerApplication.olark.orig
});
